/**
 * WebSocket connection and reconnection constants.
 */
export const WS = {
    /** Ping interval (ms) */
    PING_INTERVAL_MS: 30_000,
    /** Pong timeout — disconnect if no pong within this window (ms) */
    PONG_TIMEOUT_MS: 10_000,
    /** Initial reconnection delay (ms) */
    RECONNECT_INITIAL_MS: 1_000,
    /** Maximum reconnection delay (ms) */
    RECONNECT_MAX_MS: 30_000,
    /** Reconnection backoff multiplier */
    RECONNECT_MULTIPLIER: 1.5,
    /** Jitter factor for reconnection delays */
    RECONNECT_JITTER: 0.2,
    /** Maximum reconnection attempts (0 = infinite) */
    RECONNECT_MAX_ATTEMPTS: 0,
    /** Rate limit: max messages per second per client */
    RATE_LIMIT_MSG_PER_SEC: 100,
    /** Rate limit: token bucket refill rate */
    RATE_LIMIT_REFILL_RATE: 50,
    /** Rate limit: token bucket capacity */
    RATE_LIMIT_BUCKET_SIZE: 200,
    /** Maximum payload size (bytes) — 1MB */
    MAX_PAYLOAD_SIZE: 1_048_576,
    /** Hello/Ack handshake timeout (ms) */
    HANDSHAKE_TIMEOUT_MS: 5_000,
    /** Default server port */
    DEFAULT_PORT: 9200,
};
//# sourceMappingURL=websocket.js.map